import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useDistributorShopping = (id, page = 1, term = null, status = null, type = null) => useQuery({ queryKey: ['distributors-shopping', id, page, term, status, type], queryFn: async () => {
    if(!id) return null
    const callback = await API.get(`/distributors/${id}/shopping?page=${page}${term ? `&term=${term}` : ''}${status ? `&status=${status}` : ''}${type ? `&type=${type}` : ''}`)
    return callback?.data
}})

export default useDistributorShopping